import { List, Record } from 'immutable';
export const makeDataErrorMessage = Record({
  message: ''
});
export function makeDataErrorMessages(msgs) {
  return List(msgs).map(msg => makeDataErrorMessage({
    message: msg
  }));
}